import { calcShortcutInterval } from '@src/utils';
import { DATE_SHORTCUTS } from '@src/utils/constants';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  aiAlertMetricsMeta: any[];
  autoInsightsFilter: { alertIds: number[]; name: any };
  interval: any;
};

type Action = {
  setAIAlertMetricsMeta: (aiAlertMetricsMeta) => void;
  setAutoInsightsFilter: (autoInsightsFilter) => void;
  setInterval: (interval) => void;
};

const [from, to] = calcShortcutInterval(DATE_SHORTCUTS.past24Hours);

const initialInterval = {
  from: from.format(),
  to: to.format(),
  shortcut: DATE_SHORTCUTS.past24Hours,
};

const initialState: State = {
  aiAlertMetricsMeta: [],
  autoInsightsFilter: { alertIds: [], name: null },
  interval: initialInterval,
};

export const useAiAlertStore = create(
  devtools(
    (set: any, get: any) => ({
      ...initialState,
      setAIAlertMetricsMeta: (aiAlertMetricsMeta) =>
        set({ aiAlertMetricsMeta: aiAlertMetricsMeta }),
      setAutoInsightsFilter: (autoInsightsFilter) =>
        set({ autoInsightsFilter: autoInsightsFilter }),
      setInterval: (interval) =>
        set({
          interval: interval,
        }),
    }),
    { name: 'aiAlertStore' },
  ),
);

export default useAiAlertStore;
